<template>
  <div class="mm-button spaceCenter" :loading="loading">
    <div class="spaceCenter">
      <img class="mm-logo" src="@/assets/logo/mm-logo.png" />
      <account class="mm-text" v-if="account" :value="account" />
      <el-button type="text" v-else class="mm-text" @click="connectMetaMask">{{
        btnText
      }}</el-button>
    </div>
  </div>
</template>

<script>
import MetaMaskOnboarding from "@metamask/onboarding";
import metaMask from "./metaMask.js";
export default {
  data() {
    return {
      isInstall: true,
      isConnect: false,
      btnText: "Install MetaMask",
      loading: false,
      isLog: true,
      account: undefined
    };
  },
  methods: {
    async init() {
      return new Promise(reslove => {
        this.isInstall = metaMask.isMetaMaskInstalled();
        if (this.isInstall) {
          this.connectMetaMask(reslove);
        } else {
          reslove("not install");
        }
      });
    },
    connectMetaMask(reslove) {
      if (this.isConnect) {
        return;
      }
      if (!this.isInstall) {
        // window.open("https://metamask.io/download/")
        this.loading = true;
        this.btnText = "Onboarding in progress";
        const onboarding = new MetaMaskOnboarding();
        onboarding.startOnboarding();
        reslove();
      } else {
        this.loading = false;
        this.btnText = "Connect MetaMask";
        this.onClickConnect(reslove);
      }
    },
    async onClickConnect(reslove) {
      try {
        // Will open the MetaMask UI
        // You should disable this button while the request is pending!
        this.loading = true;
        await ethereum.request({ method: "eth_requestAccounts" });
        const accounts = await ethereum.request({ method: "eth_accounts" });
        console.log(`"accounts=",${accounts}`);
        if (!accounts[0]) {
          this.$message.error("Not able to get accounts");
        } else {
          this.account = accounts[0];
          this.btnText = "Connected";
          this.isConnect = true;
          this.$store.commit("app/SET_MATEMASK", {
            isConnect: true,
            account: accounts[0]
          });
        }
        reslove();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        reslove();
      }
    }
  },
  created() {
    this.init().then(res => {
      console.log("metamask init ok---");
    });
  }
};
</script>

<style lang="scss" scoped>
.mm-button {
  background: transparent;
  cursor: pointer;
  color: #1f1f1f;
  margin: 0.16rem auto 0 auto;

  .asset-img {
    height: 0.19rem;
    position: relative;
    top: 0.01rem;
  }
}
.mm-logo {
  height: 0.2rem;
  margin-right: 0.1rem;
}
.mm-text {
  position: relative;
  top: 0.02rem;
}
</style>
